export const CLEAN_COMMERCIAL_USERS = '@@toyota/CLEAN_COMMERCIAL_USERS';

export const SHOW_THANKS_MODAL = '@@toyota/SHOW_THANKS_MODAL_COMMERCIAL_USERS';

export const SET_EDITABLE_ROW_INDEX = '@@toyota/DELETE_COMMERCIAL_USER';
export const UPDATE_USER_DATA = '@@toyota/UPDATE_USER_DATA';
export const ADD_NEW_USER_ROW = '@@toyota/ADD_NEW_COMMERCIAL_USER_ROW';
export const UPDATE_NEW_USER_DATA = '@@toyota/UPDATE_NEW_USER_DATA';
export const DEACTIVATE_USER_ROW = '@@toyota/DELETE_USER_ROW';

export const FETCHING_COMMERCIAL_USERS = '@@toyota/FETCHING_COMMERCIAL_USERS';
export const FETCHED_COMMERCIAL_USERS = '@@toyota/FETCHED_AGENCIES_BY_DEALER_COMMERCIAL_USERS';
export const FETCHED_COMMERCIAL_USERS_FAILED = '@@toyota/FETCHED_COMMERCIAL_USERS_FAILED';

export const SENDING_COMMERCIAL_USERS_DATA = '@@toyota/SENDING_COMMERCIAL_USERS_DATA';
export const SENT_COMMERCIAL_USERS_DATA = '@@toyota/SENT_COMMERCIAL_USERS_DATA';
export const SENT_COMMERCIAL_USERS_DATA_FAILED = '@@toyota/SENT_COMMERCIAL_USERS_DATA_FAILED';

export const SENDING_COMMERCIAL_USERS_UPDATE = '@@toyota/SENDING_COMMERCIAL_USERS_UPDATE';
export const SENT_COMMERCIAL_USERS_UPDATE = '@@toyota/SENT_COMMERCIAL_USERS_UPDATE';
export const SENT_COMMERCIAL_USERS_UPDATE_FAILED = '@@toyota/SENT_COMMERCIAL_USERS_UPDATE_FAILED';
